@let model = vm;

<div class="project-role-matrix-container">
  <div class="table-container">
    <table mat-table [dataSource]="filteredRows">
      <!-- Static username column -->
      <ng-container matColumnDef="username">
        <th mat-header-cell *matHeaderCellDef>User</th>
        <td mat-cell *matCellDef="let projectAccess">
          <app-user-avatar
            [user]="{
              name: projectAccess.user?.name,
              email: projectAccess.user?.email,
              sapId: projectAccess.user?.sapId,
              role: projectAccess.role,
            }"
          ></app-user-avatar>
        </td>
      </ng-container>

      <!-- Dynamic role columns -->
      <ng-container *ngIf="model as m">
        @for (role of m.roles; track role.id ?? role.name ?? $index) {
          <ng-container [matColumnDef]="roleToColumn(role)">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="vertical-header"
              (mouseenter)="hoveredColumn = roleToColumn(role)"
              (mouseleave)="hoveredColumn = null"
              [class.highlight-column]="hoveredColumn === roleToColumn(role)"
            >
              <div class="role-header-content">
                <button
                  class="role-filter-btn"
                  [class.filter-state-true]="getFilterState(roleToColumn(role)) === true"
                  [class.filter-state-false]="getFilterState(roleToColumn(role)) === false"
                  [matTooltip]="getFilterTooltip(roleToColumn(role))"
                  (click)="cycleFilter(roleToColumn(role), $event)"
                  type="button"
                >
                  <mat-icon>{{ getFilterIcon(roleToColumn(role)) }}</mat-icon>
                </button>
                <span class="role-name">{{ role.name }}</span>
              </div>
            </th>
            <td
              mat-cell
              *matCellDef="let projectAccess"
              [ngClass]="{ 'blue-cell': hasRole(projectAccess, role, m.masks) }"
              (mouseenter)="hoveredColumn = roleToColumn(role)"
              (mouseleave)="hoveredColumn = null"
              [class.highlight-column]="hoveredColumn === roleToColumn(role)"
            >
              <div class="matrix-cell-content">
                <button mat-icon-button (click)="toggleRole(projectAccess, role, m.masks)">
                  <mat-icon>{{ getRoleIcon(projectAccess, role, m.masks) }}</mat-icon>
                </button>
              </div>
            </td>
          </ng-container>
        }
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="model?.displayedColumns; sticky: true"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: model?.displayedColumns"
        (mouseenter)="hoveredRow = row"
        (mouseleave)="hoveredRow = null"
        [class.highlight-row]="hoveredRow === row"
      ></tr>
    </table>
  </div>
</div>
